import { render, staticRenderFns } from "./ApplyClaim.vue?vue&type=template&id=4b4655d0&scoped=true"
import script from "./ApplyClaim.vue?vue&type=script&lang=js"
export * from "./ApplyClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4655d0",
  null
  
)

export default component.exports